import React from "react";
import "./Header.css";
import headerImage from "../../assets/images/header.svg";
import linkedinIcon from "../../assets/images/linkedin.png";
import githubinIcon from "../../assets/images/github.png";
import twitterinIcon from "../../assets/images/twitter.png";
import wordpressinIcon from "../../assets/images/wordpress.png";

function Header() {
  return (
    <div className="header">
      <div className="text-content">
        Rahul Banerjee
        <p>
          {" "}
          Software Developer who likes to build cool stuff and write about them
        </p>
        <p>👶 Bombay -&gt; 👦 Kuwait -&gt; 👨‍🎓 Toronto -&gt; 👨‍💻 Vancouver</p>
        <div className="icons">
          <a
            target="_blank"
            href="https://www.linkedin.com/in/rahulbanerjee2699/"
            rel="noreferrer"
          >
            <img src={linkedinIcon} alt="linkedin" />
          </a>

          <a
            target="_blank"
            href="https://github.com/rahulbanerjee26"
            rel="noreferrer"
          >
            <img src={githubinIcon} alt="linkedin" />
          </a>

          <a
            target="_blank"
            href="https://twitter.com/rahulbanerjee99"
            rel="noreferrer"
          >
            <img src={twitterinIcon} alt="linkedin" />
          </a>

          <a
            target="_blank"
            href="https://www.realpythonproject.com"
            rel="noreferrer"
          >
            <img src={wordpressinIcon} alt="linkedin" />
          </a>
        </div>
      </div>

      <div className="image-content">
        <img src={headerImage} alt="Header" />
      </div>
    </div>
  );
}

export default Header();
